export const CacheConfig = {
  forever: {
    cacheTime: Infinity,
    staleTime: Infinity,
  },
  never: {
    cacheTime: 0,
    staleTime: 0,
  },
};
